import { size } from "../styles/device";

const LAPTOP = parseInt(size.laptop, 10); // 1024
const TABLET = parseInt(size.tablet, 10); // 768

// Quantidade de itens por página por breakpoint, alinhada às colunas do grid de
// produtos (ItemList: 2 colunas mobile, 3 tablet, 4 laptop) e divisível pelo nº
// de colunas para não deixar a última linha "quebrada".
export const ITEMS_PER_PAGE = {
  mobile: 12, // 2 colunas -> 6 linhas
  tablet: 12, // 3 colunas -> 4 linhas
  laptop: 20  // 4 colunas -> 5 linhas
};

export const getBreakpoint = (width = window.innerWidth) => {
  if (width >= LAPTOP) return "laptop";
  if (width >= TABLET) return "tablet";
  return "mobile";
};

export const getItemsPerPage = (width = window.innerWidth) =>
  ITEMS_PER_PAGE[getBreakpoint(width)];
